import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { ProveedorReferenceCode } from "src/app/models/Proveedor/ProveedorReferenceCode";
import { ProveedorRulesRequest } from "src/app/models/Proveedor/ProveedorRulesRequest";
import { ProveedorTagXML } from "src/app/models/Proveedor/ProveedorTagXML";
import { TipoReferencium } from "src/app/models/Proveedor/TipoReferencium";
import { XmlTag } from "src/app/models/Proveedor/XmlTag";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Component({
	selector: "app-proveedor-rules-entry",
	templateUrl: "./proveedor-rules-entry.component.html",
	styleUrls: ["./proveedor-rules-entry.component.scss"],
})
export class ProveedorRulesEntryComponent implements OnInit {
	@Input() public relatedProveedor: Proveedor;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendRulesRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	private rulesRequestToEdit: ProveedorRulesRequest;
	public proveedorRulesForm: FormGroup;
	public tagsGroupsForm: FormGroup;
	public tagsProveedorSource: XmlTag[] = [];
	public referenceCodesSource: TipoReferencium[] = [];
	//public referenceCodesSelected: any[] = [];
	//public seleccionTagsProveedor: any[] = [];
	active = 1;
	constructor(private formBuilder: FormBuilder, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.setRuleForm();
		// this.tagsProveedorSource = [
		//   { name: "Razon Social Emisor", value: "RznSoc" },
		//   { name: "Forma Pago del Receptor", value: "FmaPago" },
		// ];
		// this.referenceCodesSource = [
		//   {name:"Guia Despacho",value:801},
		//   {name:"Factura Electronica",value:33}
		// ]
		this.tagsProveedorSource = this.localStorage.getXmlTagList();
		this.referenceCodesSource = this.localStorage.getCodeReferenceList();
		if (this.relatedProveedor) {
			this.receivedRulesToForm();
		}
		this.receivedRulesToForm();
	}

	setRuleForm() {
		this.proveedorRulesForm = this.formBuilder.group({
			requiredReferenceCodes: [],
			requiredDocumentTags: [],
			encabezadoGroup: [false],
			detallesGroup: [false],
			subtotalesInformativosGroup: [false],
			informacionesDescuentosRecargosGroup: [false],
			informacionReferenciaGroup: [false],
			comisionesOtrosCargosGroup: [false],
		});
	}

	addTagFn(name) {
		return { name: name, tag: true };
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}

	onSubmit() {
		if (this.proveedorRulesForm.valid) {
			let codigosReferencia = this.proveedorRulesForm.controls.requiredReferenceCodes.value as TipoReferencium[];
			let etiquetasFiltro = this.proveedorRulesForm.controls.requiredDocumentTags.value as XmlTag[];
			let ProveedorReferenceList: ProveedorReferenceCode[] = [];
			let ProveedorTagXMLList: ProveedorTagXML[] = [];
			codigosReferencia.forEach((cod) => {
				let ref: ProveedorReferenceCode = new ProveedorReferenceCode();
				ref.emisorId = this.relatedProveedor.emisorId;
				ref.proveedorId = this.relatedProveedor.proveedorId;
				ref.nombre = cod.descripcion;
				ref.tipoReferencia = cod.codigo.toString();
				ProveedorReferenceList.push(ref);
			});
			etiquetasFiltro.forEach((tag) => {
				let tagProveedor: ProveedorTagXML = new ProveedorTagXML();
				tagProveedor.emisorId = this.relatedProveedor.emisorId;
				tagProveedor.proveedorId = this.relatedProveedor.proveedorId;
				tagProveedor.nombre = tag.nombre;
				tagProveedor.xmlTag = tag.xmlTag;
				tagProveedor.enumTag = tag.value;
				ProveedorTagXMLList.push(tagProveedor);
			});
			let newRulesRequest: ProveedorRulesRequest = new ProveedorRulesRequest();
			//newRulesRequest.proveedorId = this.rulesRequestToEdit?this.rulesRequestToEdit.proveedorId:this.relatedProveedor.proveedorId;
			newRulesRequest.references = ProveedorReferenceList;
			newRulesRequest.tagsXml = ProveedorTagXMLList;
			newRulesRequest.emisorId = this.relatedProveedor.emisorId;
			newRulesRequest.proveedorId = this.relatedProveedor.proveedorId;
			this.sendRulesRequestEmitter.emit(newRulesRequest);
		}
	}

	receivedRulesToForm() {
		this.proveedorRulesForm.controls.requiredDocumentTags.patchValue(this.relatedProveedor.xmlTagsRules);
		this.proveedorRulesForm.controls.requiredReferenceCodes.patchValue(this.remapProveedorCodeReferencesRules(this.relatedProveedor.codeReferenceRules));
	}

	remapProveedorCodeReferencesRules(refRules: ProveedorReferenceCode[]): TipoReferencium[] {
		let refList: TipoReferencium[] = [];
		refRules.forEach((rule) => {
			let tipoReferencium: TipoReferencium = new TipoReferencium();
			tipoReferencium.codigo = +rule.tipoReferencia;
			tipoReferencium.descripcion = rule.nombre;
			refList.push(tipoReferencium);
		});

		return refList;
	}

	getTagsByRange(addGroup, startCode: number, endCode): void {
		let tagSelectedList: XmlTag[] = [];
		if (addGroup) {
			let currentSelectedTags = this.proveedorRulesForm.controls.requiredDocumentTags.value as XmlTag[];
			tagSelectedList = this.tagsProveedorSource.filter((tag) => tag.value >= startCode && tag.value <= endCode);
			tagSelectedList = tagSelectedList.concat(currentSelectedTags);
		} else {
			let currentSelectedTags = this.proveedorRulesForm.controls.requiredDocumentTags.value;
			tagSelectedList = currentSelectedTags.filter((tag) => tag.value < startCode || tag.value > endCode);
		}
		this.proveedorRulesForm.controls.requiredDocumentTags.patchValue(tagSelectedList);
	}
}
